import type { KeyboardEvent } from 'react'

// Keys on a document's lines (docs/plans/receive-tidy.md). ↑ ↓ go to the same column on the next
// line, Enter to the next box on this line. A row carries `data-line` (its line) and the row
// with the columns also `data-main`. Past either end, `onEnd` takes the focus.

function land(box: HTMLInputElement) {
  box.focus()
  box.select()
}

/** The browser's list of past values is showing: the arrows and Enter belong to it. */
function listInUse(box: HTMLInputElement) {
  const text = box.value.trim().toLowerCase()
  if (!box.list || !text) return false
  const options = [...box.list.options].map((o) => o.value.toLowerCase())
  return !options.includes(text) && options.some((o) => o.includes(text))
}

export function lineKeyDown(e: KeyboardEvent<HTMLElement>, onEnd: () => void) {
  if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown' && e.key !== 'Enter') return
  if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return
  const box = e.target
  if (!(box instanceof HTMLInputElement) || listInUse(box)) return
  const row = box.closest<HTMLTableRowElement>('tr[data-line]')
  const body = row?.closest('tbody')
  if (!row || !body) return

  if (e.key === 'Enter') {
    const boxes = [
      ...body.querySelectorAll<HTMLInputElement>(`tr[data-line="${row.dataset.line}"] input`),
    ].filter((b) => !b.disabled && b.type !== 'hidden' && b.type !== 'checkbox')
    const next = boxes[boxes.indexOf(box) + 1]
    e.preventDefault()
    if (next) land(next)
    else onEnd()
    return
  }

  if (row.dataset.main === undefined) return
  const column = box.closest('td')?.cellIndex ?? -1
  const rows = [...body.querySelectorAll<HTMLTableRowElement>('tr[data-main]')]
  const step = e.key === 'ArrowDown' ? 1 : -1
  e.preventDefault()
  for (let at = rows.indexOf(row) + step; at >= 0 && at < rows.length; at += step) {
    const next = rows[at]!.cells[column]?.querySelector('input')
    if (next) return land(next)
  }
  if (step === 1) onEnd()
}
